import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdminService} from '../../../../services/admin.service';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { BpAdministrationService } from '../../../../services/bp-administration.service';
import { CardInfo, InteractionQueue } from '../../../../Models/human-interaction/cardInfo';
import {HumanInteractionTokenResult} from '../../../../Models/humanInteractionTokenResult';

@Component({
  selector: 'app-queue-card',
  templateUrl: './queue-card.component.html',
  styleUrls: ['./queue-card.component.css']
})
export class QueueCardComponent implements OnInit {

  @Input() cardInfo: CardInfo;
  @Input() queueInfo: InteractionQueue;
  @Input() showLabel: boolean;
  @Input() columnPropertyName: string;
  @Input() isPreview: boolean;
  @Input() userStatePermissions;


  showColunmLabel: boolean;

  constructor(
    private formBuilder: FormBuilder,
    private admService: AdminService,
    private bpService: BusinessProcessService,
    private bpAdmService: BpAdministrationService
  ) { }

  ngOnInit() {
    this.showColunmLabel = this.showLabel && this.queueInfo[this.columnPropertyName] && this.queueInfo[this.columnPropertyName].length > 0;
  }

  getValue(column) {
    if (column) {
      if (this.columnPropertyName === 'fieldColumns') {
        return this.cardInfo.values[column.columnOrder] ? this.cardInfo.values[column.columnOrder] : "";
      } else {
        return this.cardInfo.values[column.id - 1] ? this.cardInfo.values[column.id - 1] : "";
      }
    } else {
      return "";
    }
  }

  onInteract(cardInfo) {
    this.bpService.openWindowInteraction(cardInfo.businessProcessInstanceId, false);
  }

  onView(cardInfo) {
    this.bpService.openWindowInteraction(cardInfo.businessProcessInstanceId, true);
  }
}



